export default "/images/4cc9839b2993f0096ace8bf50e32e7c0.avif";